const ErrorMessage = ({ message }) => {
  return (
    <div className="w3-container w3-padding-small w3-center">
      <label className="error-label">{message}</label>
    </div>
  );
};

export default ErrorMessage;
